import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "audit-log-container page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "row p-3 pb-0" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "row p-3" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "col-md-9" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "row p-3" }
const _hoisted_22 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_24 = { class: "col-md-7" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-12 p-4" }
const _hoisted_27 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_28 = { class: "p-datatable-thead" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, "#", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_35 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader, {
                onExportCsvEvent: _ctx.exportCsv,
                onExportExcelEvent: _ctx.exportExcel,
                renderExportLog: !_ctx.isLoading && _ctx.pagination != null
              }, null, 8, ["onExportCsvEvent", "onExportExcelEvent", "renderExportLog"]),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.employees,
                          optionLabel: "name",
                          optionValue: "identifier",
                          placeholder: "Employee",
                          modelValue: _ctx.filterEmployeeModel.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterEmployeeModel.value) = $event)),
                          filter: true,
                          showClear: true
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Calendar, {
                          dateFormat: "yy-mm-dd",
                          selectionMode: "range",
                          manualInput: true,
                          placeholder: "Date Range",
                          modelValue: _ctx.filterDateModel,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterDateModel) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_MultiSelect, {
                          options: _ctx.actionPerformeds,
                          optionLabel: "name",
                          optionGroupLabel: "name",
                          optionGroupChildren: "actions",
                          optionValue: "value",
                          filter: "",
                          placeholder: "Action Performed",
                          modelValue: _ctx.filterActionPerformedModel.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterActionPerformedModel.value) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.companies,
                          optionLabel: "code",
                          optionValue: "code",
                          filter: "",
                          filterFields: ['code', 'name'],
                          showClear: "",
                          placeholder: _ctx.isCompanyLoading ? ('Loading...') : 'Company',
                          loading: _ctx.isCompanyLoading,
                          modelValue: _ctx.filterCompanyModel.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCompanyModel.value) = $event))
                        }, {
                          value: _withCtx((slotProps) => [
                            (slotProps.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.filterCompanyCodeByValue(slotProps.value)), 1),
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.filterCompanyNameByValue(slotProps.value)), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(slotProps.placeholder), 1))
                          ]),
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(slotProps.option.code), 1),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["options", "placeholder", "loading", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "10",
                          placeholder: "Company Code",
                          modelValue: _ctx.filterActionCommentModel.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterActionCommentModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.find(1))),
                          label: "Search"
                        }),
                        _hoisted_23,
                        _createVNode(_component_Button, {
                          class: "p-button-sm p-button-secondary",
                          onClick: _ctx.reset,
                          label: "Reset"
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        (_ctx.pagination.currentPage != 0)
                          ? (_openBlock(), _createBlock(_component_Paginator, {
                              key: 0,
                              first: _ctx.paginator,
                              pageLinkSize: 3,
                              rows: _ctx.pagination.itemsPerPage,
                              totalRecords: _ctx.pagination.totalItems,
                              onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.find($event.page + 1)))
                            }, null, 8, ["first", "rows", "totalRecords"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("table", _hoisted_27, [
                          _createElementVNode("thead", _hoisted_28, [
                            _createElementVNode("tr", null, [
                              _hoisted_29,
                              _createElementVNode("th", {
                                style: {"width":"25%","cursor":"pointer"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('x.employee.name')))
                              }, [
                                _createTextVNode("Name "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.employee.name' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _createElementVNode("th", {
                                style: {"width":"20%","cursor":"pointer"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('x.actionDate')))
                              }, [
                                _createTextVNode("Action Date "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.actionDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _createElementVNode("th", {
                                style: {"width":"42%","cursor":"pointer"},
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sort('x.actionPerformed')))
                              }, [
                                _createTextVNode("Action Performed "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.actionPerformed' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_30
                            ])
                          ]),
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.auditLogs, (auditLog, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: index,
                                    onClick: ($event: any) => (_ctx.viewActionComment(auditLog))
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(((_ctx.pagination.currentPage - 1) * _ctx.pagination.itemsPerPage) + index + 1), 1),
                                    _createElementVNode("td", null, _toDisplayString(auditLog.name), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatToDateTime(auditLog.actionDate)), 1),
                                    _createElementVNode("td", null, _toDisplayString(auditLog.actionPerformed), 1),
                                    _createElementVNode("td", null, [
                                      (auditLog.actionComment != null)
                                        ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                            key: 0,
                                            icon: ['fas', 'message'],
                                            size: "sm"
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 8, _hoisted_32))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.isLoading && _ctx.pagination.auditLogs.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: ['fas', 'image'],
                              size: "2x"
                            }),
                            _hoisted_34
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Action Comment",
      visible: _ctx.displayModal,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.displayModal) = $event)),
      style: {width: '50vw'},
      draggable: false,
      modal: true,
      closable: true,
      onHide: _ctx.closeActionComment
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_Card, { class: "card-audit-log" }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.auditLog.actionPerformed), 1)
            ]),
            content: _withCtx(() => [
              (_ctx.isActionCommentLoading)
                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("pre", null, _toDisplayString(_ctx.auditLog.actionComment), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}